export default {
  "AgreementModalThirdParty.Name":
    "ドコモまたはドコモFGからのパートナーへの第三者提供",
  "AgreementModalThirdParty.CardDetail":
    "ドコモおよびNTTドコモ・フィナンシャルグループ（以下、ドコモFG）は、以下のとおり、お客さまに関する情報を第三者に提供することがあります",
  "AgreementModalThirdParty.CardDetail2": "【提供情報】",
  "AgreementModalThirdParty.CardDetail3":
    "お客さまに関する以下の情報（なお、氏名／電話番号／メールアドレスを元の情報がわからないようハッシュ化などにより不可逆な状態に加工した情報は基本情報に含みますが、氏名／電話番号／メールアドレスをそのまま提供する場合およびドコモが電気通信事業者の取扱中に係る通信の秘密に該当する情報を提供する場合は、別途同意を取得します）",
  "AgreementModalThirdParty.CardDetail4": "基本情報",
  "AgreementModalThirdParty.CardDetail5":
    "お客さまの識別子、属性、連絡先、dポイントサービスのご利用に関する情報です。例として、dポイントカード番号、性別、年齢、家族構成、住所、dポイント残高、dポイント利用履歴などが含まれます",
  "AgreementModalThirdParty.CardDetail6": "利用情報",
  "AgreementModalThirdParty.CardDetail7":
    "各種サービスなどのご契約・ご利用などに関する情報です。例として、ドコモおよびドコモFGの各種サービスのご契約状態・ご利用履歴・投稿された記事や画像・動画に関する情報、インターネット利用時の行動に関する情報、アプリケーション利用時の行動に関する情報、購入されたサービスや商品の名称・購入場所・決済に関する情報、アンケートの回答に関する情報などが含まれます。ただし、基本情報、位置情報、医療健康情報に該当する情報は除きます",
  "AgreementModalThirdParty.CardDetail8": "位置情報",
  "AgreementModalThirdParty.CardDetail9":
    "移動体端末の所持者の所在を表す場所を示す情報です。例として、端末のGPS機能のほか、Wi-Fiまたはそのほかの近距離無線通信技術、携帯電話基地局により測位される位置情報（位置登録情報を含みますが、これに限りません）などが含まれます",
  "AgreementModalThirdParty.CardDetail10": "医療健康情報",
  "AgreementModalThirdParty.CardDetail11":
    "ドコモおよびドコモFGのサービスを利用した際に取得される、お客さまの医療や健康に関する情報です。例として、医師などによる健康診断そのほかの検査に関する情報、医師などによる保健指導・診療・調剤に関する情報、お客さまの身長・体重、活動量などが含まれます",
  "AgreementModalThirdParty.CardDetail12": "なお、上記情報には、ドコモが「",
  "AgreementModalThirdParty.LinkText": "NTTドコモ プライバシーポリシー",
  "AgreementModalThirdParty.CardDetail13":
    "」に基づき実施した分析結果またはドコモFGが「",
  "AgreementModalThirdParty.LinkText2":
    "NTTドコモ・フィナンシャルグループ　プライバシーポリシー",
  "AgreementModalThirdParty.CardDetail14":
    "」に基づき実施した分析結果も含まれ、その分析結果の性質に応じて各情報に区分したうえ管理しています",
  "AgreementModalThirdParty.CardDetail15": "【提供先】",
  "AgreementModalThirdParty.CardDetail16": "グループ会社",
  "AgreementModalThirdParty.CardDetail17":
    "ドコモの場合：ドコモの連結子会社および持分法適用会社",
  "AgreementModalThirdParty.CardDetail18":
    "ドコモFGの場合：ドコモ、ならびにドコモFGの連結子会社および持分法適用会社",
  "AgreementModalThirdParty.CardDetail19":
    "dポイント加盟店（共通ポイントサービス※の提供を受けることができる店舗またはWebサイトなどの運営事業者などをいいます）",
  "AgreementModalThirdParty.CardDetail20":
    "所定の店舗などでの決済などでｄポイントを「ためる・つかう」、おススメ情報の配信・DM送付など",
  "AgreementModalThirdParty.CardDetail21":
    "ただし、【提供情報】のうち医療健康情報は、別途同意をいただいた場合にのみ提供します",
  "AgreementModalThirdParty.CardDetail22":
    "提携先事業者など（ドコモまたはドコモFGと提携関係にある事業者などをいいます）",
  "AgreementModalThirdParty.CardDetail23":
    "ただし、【提供情報】のうち医療健康情報は、別途同意をいただいた場合にのみ提供します",
  "AgreementModalThirdParty.CardDetail24":
    "提供先の事業者名（外国にある第三者を含みます）や所在国の個人情報保護制度など（外国にある第三者の場合）に関する情報はドコモについては「",
  "AgreementModalThirdParty.LinkText3": "第三者提供先",
  "AgreementModalThirdParty.CardDetail25": "」、ドコモFGについては「",
  "AgreementModalThirdParty.LinkText4": "ドコモFGの第三者提供先",
  "AgreementModalThirdParty.CardDetail26":
    "」に掲載しております（提供先は随時追加・変更することがあります）",
  "AgreementModalThirdParty.CardDetail27": "【提供の目的】",
  "AgreementModalThirdParty.CardDetail28":
    "提供先が実施する各種キャンペーンやイベントの案内そのほか提供先が適切と判断したサービスや商品（提供先以外の第三者のサービス・商品を含みます）に関する情報提供や広告の実施のため",
  "AgreementModalThirdParty.CardDetail29":
    "提供先のサービスや商品の販売状況、dポイントカードなどの利用状況の調査および分析、提供先のサービス（ドコモが「",
  "AgreementModalThirdParty.LinkText5": "NTTドコモ プライバシーポリシー",
  "AgreementModalThirdParty.CardDetail30": "」に定める目的またはドコモFGが「",
  "AgreementModalThirdParty.LinkText6":
    "NTTドコモ・フィナンシャルグループ　プライバシーポリシー",
  "AgreementModalThirdParty.CardDetail31":
    "」に定める目的で利用するために、ドコモまたはドコモFGから提供されたパーソナルデータに提供先の独自データを付加したうえで返却するサービスを含みます）や商品の運用・改善および、新商品や新サービスの企画、アンケート調査そのほかマーケティング分析のため",
  "AgreementModalThirdParty.CardDetail32":
    "提携先事業者などが定める個人情報の利用目的を達成するため（提携先事業者などに提供する場合に限ります）",
  "AgreementModalThirdParty.CardDetail33":
    "位置情報の活用例はこちらをご参照ください",
  "AgreementModalThirdParty.LinkText7": "ナットク！位置情報のトリセツ",
  "AgreementModalThirdParty.CardDetail34": "【そのほか提供条件】",
  "AgreementModalThirdParty.CardDetail35":
    "この同意に基づく提供は、ドコモまたはドコモFGがお客さまのパーソナルデータを第三者に提供することに関するほかの同意事項の内容にかかわらず行うことがあります",
  "AgreementModalThirdParty.CardDetail36":
    "本同意事項への同意の有無にかかわらず、ドコモおよびドコモFGは、法令により認められる範囲で、【提供情報】を【提供先】そのほかの第三者に提供する場合があります",
  "AgreementModalThirdParty.CardDetail37":
    "そのほか、パートナーへの【提供情報】の提供については、ドコモおよびドコモFGがそれぞれ定める「",
  "AgreementModalThirdParty.LinkText8":
    "パーソナルデータの取扱いに関するその他の事項の公表",
  "AgreementModalThirdParty.CardDetail38": "」に基づき取扱います",
  "AgreementModalThirdParty.CardDetail39":
    "提供情報には金融商品仲介業を営むドコモFGが、金融商品取引法に基づき取得した、お客さまとのお取引に関する情報を含みます",
  "AgreementModalThirdParty.CardDetail40": "【備考】",
  "AgreementModalThirdParty.CardDetail41":
    "ドコモまたはドコモFGからのパートナーへの第三者提供についてお客さまが同意している範囲は、同意後に「",
  "AgreementModalThirdParty.LinkText9": "パーソナルデータダッシュボード",
  "AgreementModalThirdParty.CardDetail42":
    "」で確認・変更いただくことができます（パーソナルデータダッシュボードの仕様は随時見直すことがあります）",
}
